"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSeaview(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#E6E9EE"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 16.507c1.034-.343 1.87-1.023 2.507-2.041 1.415 1.79 5.094 2.2 6.9 0 2.017 1.483 5.19 2.507 6.988 0 .85.733 2.059 1.594 3.447 1.528M2 21.292c1.034-.343 1.87-1.023 2.507-2.041 1.415 1.79 5.094 2.2 6.9 0 2.017 1.483 5.19 2.507 6.988 0 .85.733 2.059 1.594 3.447 1.528"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.053 11.23a2.632 2.632 0 100-5.262 2.632 2.632 0 000 5.263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5l4.73-1.67M4 7l6.063.91M8 3.357l2.88 2.468M14 4.5V2m3 4l2.037-1.698M18 8.5h3m-1 4l-2.686-1.791"
  }));
}

var MemoSvgSeaview = /*#__PURE__*/React.memo(SvgSeaview);
var _default = MemoSvgSeaview;
exports["default"] = _default;